export default __webpack_public_path__ + "static/media/Bane.54fc2e3f.png";